<div class="max-w-lg mx-auto">
	<img src="../../../assets/images/gfx-heartbeat.webp" alt="GFX Logo" class="w-28 mx-auto" />
	<h2 class="text-center">Creating your new account. Just one moment.</h2>
</div>
